import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CustomerDbModel, CustomFieldsDao } from '../db-models/appointment-custom-fields-dao';
import { PartnerService } from './partner.service';

@Injectable({
  providedIn: 'root'
})
export class CustomersService {

  private http = inject(HttpClient);
  private partnerService = inject(PartnerService);

  customFieldsBefore: CustomFieldsDao[] = [];
  customFieldsAfter: CustomFieldsDao[] = [];


  getCustomers(): Observable<CustomerDbModel[]> {
    let params = new HttpParams()
      .set('limit', 30)
      .set('offset', 0);

    const partnerVerificationCode = this.partnerService.partnerVerificationCode;
    partnerVerificationCode && (params = params.append('token', partnerVerificationCode));

    return this.http.get<CustomerDbModel[]>(environment.apiUrl + 'customers', { params: params });
  }

  getCustomersByUuid(uuid: string): Observable<{ customer: CustomerDbModel }> {
    return this.http.get<{ customer: CustomerDbModel }>(environment.apiUrl + 'customers/' + uuid);
  }

  searchCustomersByTag(tag: string, limit?: number, offset?: number): Observable<CustomerDbModel[]> {
    const body: { query: string, appendpartnerVerificationCode: boolean } = { query: tag, appendpartnerVerificationCode: true };
    let params: HttpParams;
    if (limit && offset) {
      params = new HttpParams()
        .set('limit', limit + '')
        .set('offset', offset + '');
    }
    return this.http.post<CustomerDbModel[]>(`${environment.apiUrl}customers/search`, body, { params: params ? params : {} });
  }

  sendOtp(param: { customer_uuid: string, retry?: boolean }): Observable<{ success: boolean, code: number, message: string }> {
    return this.http.post<{ success: boolean, code: number, message: string }>(environment.apiUrl + 'customers/widget_sent_otp', param, {})
  }

  verifyOtp(param: { otp: string, customer_uuid: string }): Observable<{ success: boolean, code: number, message: string }> {
    return this.http.post<{ success: boolean, code: number, message: string }>(environment.apiUrl + 'customers/widget_verify_otp', param, {})
  }

  authenticateCustomerToken(param: { token: string }): Observable<{ success: boolean, data: Record<string, any> }> {
    return this.http.post<{ success: boolean, data: Record<string, any> }>(
      environment.apiUrl + 'customers/verify-token',
      param,
      {}
    );
  }
}
